import { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useUpdateFolder } from 'api/hooks/use-folders'
import { useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

const EditFolderModal = ({ folder, show, onHide }) => {
  const [name, setName] = useState('')
  const queryClient = useQueryClient()

  useEffect(() => {
    if (folder) {
      setName(folder.name)
    }
  }, [folder])

  const { mutate: updateFolder, isLoading } = useUpdateFolder({
    options: {
      onSuccess: () => {
        onHide()
        queryClient.invalidateQueries('folders')
      },
      onError: () => {
        toast.error('Failed to update folder')
      }
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (name.trim() && folder?.id) {
      updateFolder({ id: folder.id, name: name.trim() })
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Folder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Folder Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter folder name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={100}
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="white" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={!name.trim() || isLoading}>
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default EditFolderModal
